import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Facebook, Instagram, Twitter, Youtube } from 'lucide-react';
import { SITE, CATEGORIES } from '../mock/mock';

const Footer = () => {
  return (
    <footer className="ps-blue-bg text-white mt-20">
      <div className="h-1.5 ps-yellow-bg w-full" />
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full ps-yellow-bg flex items-center justify-center border-4 border-white">
              <span className="font-anton text-[12px] text-[#1a1ad6]">30</span>
            </div>
            <span className="font-anton text-xl">PETSPORTS<span className="text-[#ffd400]">EQUIP</span></span>
          </div>
          <p className="text-white/70 text-sm leading-relaxed">Making life a little more fun since 1995. Safe, durable, premium-quality toys & accessories for pets and home.</p>
          <div className="flex gap-3 mt-5">
            {[Facebook, Instagram, Twitter, Youtube].map((Icon, i) => (
              <a key={i} href="#" onClick={(e) => e.preventDefault()} className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#ffd400] hover:text-black flex items-center justify-center transition-colors">
                <Icon size={17} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-oswald uppercase tracking-wide text-[#ffd400] mb-4">Shop</h4>
          <ul className="space-y-2 text-sm text-white/80">
            {CATEGORIES.slice(0, 6).map((c) => (
              <li key={c.slug}><Link to={`/category/${c.slug}`} className="hover:text-[#ffd400] transition-colors">{c.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-oswald uppercase tracking-wide text-[#ffd400] mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/" className="hover:text-[#ffd400] transition-colors">Home</Link></li>
            <li><Link to="/new" className="hover:text-[#ffd400] transition-colors">New Products</Link></li>
            <li><Link to="/products" className="hover:text-[#ffd400] transition-colors">All Products</Link></li>
            <li><Link to="/contact" className="hover:text-[#ffd400] transition-colors">Wholesale</Link></li>
            <li><Link to="/contact" className="hover:text-[#ffd400] transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-oswald uppercase tracking-wide text-[#ffd400] mb-4">Get In Touch</h4>
          <a href={`tel:${SITE.phoneLink}`} className="flex items-center gap-2 text-sm text-white/80 hover:text-[#ffd400] mb-3 transition-colors">
            <Phone size={16} /> {SITE.phone}
          </a>
          <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 text-sm text-white/80 hover:text-[#ffd400] transition-colors">
            <Mail size={16} /> {SITE.email}
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-white/60">
          <span>© {new Date().getFullYear()} {SITE.domain}. All rights reserved.</span>
          <span>All toys certified non-toxic by independent third-party laboratories.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
